import { render, staticRenderFns } from "./TabProjecaoHeppi.vue?vue&type=template&id=41348838"
import script from "./TabProjecaoHeppi.vue?vue&type=script&lang=js"
export * from "./TabProjecaoHeppi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports